import { useMemo } from 'react';
import { useEntityStore } from '@/lib/sync/entity-store';
import type { ConversationRow } from '@/lib/sync/entity-store';

/**
 * Visible conversation history: non-archived, pinned first, then sorted by
 * latestActivityAt descending. Reads the `conversations` Map populated by
 * entity sync (M3).
 */
export function useConversationList(): ConversationRow[] {
  const conversations = useEntityStore((s) => s.conversations);
  return useMemo(() => {
    return [...conversations.values()]
      .filter((c) => !c.isArchived)
      .sort((a, b) => {
        if (a.isPinned !== b.isPinned) return a.isPinned ? -1 : 1;
        // latestActivityAt is a UTC ISO-8601 string; lexical compare sorts it
        // chronologically (same format + offset), so no Date parsing needed.
        return b.latestActivityAt.localeCompare(a.latestActivityAt);
      });
  }, [conversations]);
}
